<script lang="ts">
	import { Alert } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import { onMount } from 'svelte';
	import { energyPriceColorSchemes, type ColorSchemeKey } from '../../utils/colorSchemes';
	import VerivoxAttribution from '../../verivox/VerivoxAttribution.svelte';

	export let onCtaClick: () => void;

	let energyPriceScheme: ColorSchemeKey = 'scheme1';

	onMount(() => {
		energyPriceScheme = energyPriceColorSchemes.getCurrentScheme();
	});
</script>

<div class="pl-s pr-s pt-s pb-s">
	<div
		class="energy-price-alert-wrapper pl-s pr-s pt-s pb-s"
		style="background: {energyPriceColorSchemes.schemes[energyPriceScheme]}"
	>
		<Alert
			isHeadingBold
			type="success"
			customIcon="fas fa-bolt"
			heading={$format('energy_price_setup_prompt_title', {
				default: 'Günstige Stromtarife entdecken',
				locale: 'de',
			})}
			message={$format('energy_price_setup_prompt_message', {
				default: 'Vergleichen Sie verfügbare Stromtarife in Ihrer Region',
				locale: 'de',
			})}
			cta={{
				title: $format('button_get_started', {
					default: 'Loslegen',
					locale: 'de',
				}),
			}}
			on:cta_click={onCtaClick}
		/>
		<VerivoxAttribution />
	</div>
</div>

<style>
	.energy-price-alert-wrapper {
		border-radius: 8px;
		position: relative;
		overflow: hidden;
	}

	.energy-price-alert-wrapper::before {
		content: '';
		position: absolute;
		top: -50%;
		right: -10%;
		width: 100px;
		height: 100px;
		background: rgba(255, 255, 255, 0.1);
		border-radius: 50%;
		pointer-events: none;
	}

	:global(.energy-price-alert-wrapper .alert) {
		background: transparent !important;
		border: none !important;
	}

	:global(.energy-price-alert-wrapper .alert-heading),
	:global(.energy-price-alert-wrapper .alert-message) {
		color: #ffffff !important;
	}

	:global(.energy-price-alert-wrapper .alert-icon) {
		color: #ffffff !important;
	}

	:global(.energy-price-alert-wrapper .alert-cta),
	:global(.energy-price-alert-wrapper .alert-cta-link),
	:global(.energy-price-alert-wrapper a[class*='cta']),
	:global(.energy-price-alert-wrapper button[class*='cta']) {
		background: rgba(255, 255, 255, 0.95) !important;
		color: #0891b2 !important;
		border: none !important;
		border-radius: 8px !important;
		padding: 10px 20px !important;
		font-size: 13px !important;
		font-weight: 600 !important;
		text-decoration: none !important;
		display: inline-flex !important;
		align-items: center !important;
		gap: 6px !important;
		transition: all 0.2s ease !important;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;
		cursor: pointer !important;
	}

	:global(.energy-price-alert-wrapper .alert-cta:hover),
	:global(.energy-price-alert-wrapper .alert-cta-link:hover),
	:global(.energy-price-alert-wrapper a[class*='cta']:hover),
	:global(.energy-price-alert-wrapper button[class*='cta']:hover) {
		background: #ffffff !important;
		transform: translateY(-1px) !important;
		box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
	}

	:global(.energy-price-alert-wrapper .alert-bottom a),
	:global(.energy-price-alert-wrapper .alert-bottom button),
	:global(.energy-price-alert-wrapper [slot='bottom'] a),
	:global(.energy-price-alert-wrapper [slot='bottom'] button) {
		background: rgba(255, 255, 255, 0.95) !important;
		color: #0891b2 !important;
		border: none !important;
		border-radius: 8px !important;
		padding: 10px 20px !important;
		font-size: 13px !important;
		font-weight: 600 !important;
		text-decoration: none !important;
		display: inline-flex !important;
		align-items: center !important;
		gap: 6px !important;
		transition: all 0.2s ease !important;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;
		cursor: pointer !important;
	}

	:global(.energy-price-alert-wrapper .alert-bottom a:hover),
	:global(.energy-price-alert-wrapper .alert-bottom button:hover),
	:global(.energy-price-alert-wrapper [slot='bottom'] a:hover),
	:global(.energy-price-alert-wrapper [slot='bottom'] button:hover) {
		background: #ffffff !important;
		transform: translateY(-1px) !important;
		box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
	}
</style>
